<template>
  <vx-card v-bind:title="capitalize($t('attribute.payment'))" class="shadow-lg vs-con-loading__container">
    <div id="payment-box">
      <template v-if="payment_errors.length > 0">
        <div class="mb-2" v-for="error in payment_errors" :key="error.message">
          <vs-alert color="danger" icon="new_releases">
            <span>{{ error }}</span>
          </vs-alert>
        </div>
      </template>
      <div class="w-full mb-3">
        <template v-if="payment_method == 'PAYNOW'">
          <img :src="$endpoints.paynow_qrcode" style="width: 70%; margin-left:auto; margin-right:auto" />
        </template>
        <template v-if="payment_method == 'BANK_TRANSFER'">
          <img :src="$endpoints.bank_transfer" style="width: 70%; margin-left:auto; margin-right:auto" />
        </template>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full lg:w-1/3" v-if="is_bank_transfer">
          <vs-button
            :disabled="loadingBtnCheckout"
            class="w-full p-5 m-1"
            :key="`BANK_TRANSFER_${payment_method}`"
            :color="renderPaymentMethodButtonColor('BANK_TRANSFER')"
            :type="renderPaymentMethodButtonType('BANK_TRANSFER')"
            @click="onClickChangePaymentMethod('BANK_TRANSFER')"
          >
            <i class="material-icons">account_balance</i><br />
            <small class="font-bold text-uppercase">{{ $t("attribute.bankTransfer") }}</small>
          </vs-button>
        </div>
        <div class="vx-col w-full lg:w-1/3" v-if="isPayNow">
          <vs-button
            :disabled="loadingBtnCheckout"
            class="w-full p-5 m-1"
            :key="`PAYNOW_${payment_method}`"
            :color="renderPaymentMethodButtonColor('PAYNOW')"
            :type="renderPaymentMethodButtonType('PAYNOW')"
            @click="onClickChangePaymentMethod('PAYNOW')"
          >
            <i class="material-icons">account_balance</i><br />
            <small class="font-bold">PAYNOW</small>
          </vs-button>
        </div>
      </div>
      <vs-divider />
      <br />
      <vs-button
        class="w-full p-3 m-1 font-bold"
        type="gradient"
        color="primary"
        @click="onClickCheckout()"
        :disabled="loadingBtnCheckout"
        >CHECKOUT</vs-button
      >
    </div>
  </vx-card>
</template>

<script>
import Crypto from "@/helper/crypto";
import ErrorHandler from "@/helper/error_handler";
import Global from "@/helper/global";
import { createToken } from "vue-stripe-elements-plus";

export default {
  name: "manual-payment-box",
  props: ["loadingBtnCheckout"],
  props: {
    loadingBtnCheckout: Boolean,
    is_bank_transfer: {
      type: Boolean,
      default: false,
    },
    isPayNow: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      payment_errors: [],
      payment_method: "BANK_TRANSFER",
    };
  },
  methods: {
    async onClickCheckout() {
      let details = {
        method: this.payment_method,
      };

      this.$emit("onClickCheckout", details);
    },
    onClickChangePaymentMethod(type) {
      this.payment_method = type;
    },
    renderPaymentMethodButtonType(type) {
      return this.payment_method === type ? "filled" : "border";
    },
    renderPaymentMethodButtonColor(type) {
      return this.payment_method === type ? "primary" : "primary";
    },
  },
};
</script>
